module.exports = __webpack_public_path__ + "static/media/d2.23125afe.png";